import users from "../../mock-data/users";
import gameOffers from "../../mock-data/gameOffers";
import gameMode from "../../mock-data/gameMode";
import organizationAgencies from "../../mock-data/organizationAgencies";
import roles from "../../mock-data/roles";
import salePoints from "../../mock-data/salePoints";
import allOrganizations from "../../mock-data/organizations/";
import lottery from "../../mock-data/lottery";
import { setConcentratorsError } from "../../store/slices/errors";
import ConfigsSearcher from "../../config/Configs";
import apiClient from "../../utils/api.client";

let devEnv = process.env.NODE_ENV === "development";

/* export const gammaServices = () => {

  const config = ConfigsSearcher();

  const getAgencyServiceUrl = () => {
    return devEnv ? "/gamma-agencies" : config.configFinder('AGENCY_SERVICE');
  }

  const getUsersServiceUrl = () => {
    return devEnv ? "/gamma-users" : config.configFinder('USERS_SERVICE');
  }

  const getOrganizationServiceUrl = () => {
    return devEnv ? "/gamma-organizations" : config.configFinder('ORGANIZATIONS_SERVICE');
  }

  const getAllOrganizationServiceUrl = () => {
    return devEnv ? "/gamma-all-organizations" : config.configFinder('GAME_ORGANIZATION_SERVICE');
  } */

const getloggedUser = async (userId) => {
  /* return fetch(`${getUsersServiceUrl()}/users/${userId}`)
    .then((response) => response)
    .catch((err) => console.log(err)); */
  let url = `/gamma-users/users/${userId}`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getGameOffers = async (organizationId, pageNumber) => {
  /* return fetch(`${getOrganizationServiceUrl()}/organizations/${organizationId}/gameOffers?pageNumber=${pageNumber}&pageSize=10&orderCriteria=ASC&orderField=id`)
    .then((response) => response)
    .catch((err) => console.log(err)); */
  let url = `/gamma-organizations/organizations/${organizationId}/gameOffers?pageNumber=${pageNumber}&pageSize=10&orderCriteria=ASC&orderField=id`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getGameoffers", error);
    throw error;
  }
};

const getGameMode = async () => {
  /* return fetch(`${getOrganizationServiceUrl()}/modes?pageNumber=1&pageSize=20&orderCriteria=ASC&orderField=name`)
    .then((response) => response)
    .catch((err) => console.log(err)); */
  let url = `/gamma-organizations/modes?pageNumber=1&pageSize=20&orderCriteria=ASC&orderField=name`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getLottery = async () => {
  /* return fetch(`${getOrganizationServiceUrl()}/lotteries?pageNumber=1&pageSize=20&orderCriteria=ASC&orderField=name`)
    .then((response) => response.json())
    .then((json) => { return json })
    .catch((err) => console.log(err)); */
  let url = `/gamma-organizations/lotteries?pageNumber=1&pageSize=20&orderCriteria=ASC&orderField=name`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getOrganizationAgencies = async (organizationId, pageNumber) => {
  /* return fetch(`${getAgencyServiceUrl()}/organizations/${organizationId || 9}/agencies?pageNumber=${pageNumber || 1}&pageSize=10&orderCriteria=ASC&orderField=name&agencyKind=CONCENTRATOR`, {
    method: "GET",
    headers: { 'Content-Type': 'application/json' }
  })
    .then((response) => response)
    .catch((err) => console.log(err)); */
  let url = `/gamma-agencies/organizations/${organizationId || 9}/agencies?pageNumber=${pageNumber || 1}&pageSize=10&orderCriteria=ASC&orderField=name&agencyKind=CONCENTRATOR`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getOrganizationSortedAgencies = async (
  organizationId,
  pageNumber,
  perPage,
  sortCriteria,
  sortItem,
  dispatch,
) => {
  /* return fetch(`${getAgencyServiceUrl()}/organizations/${organizationId || 9}/agencies?pageNumber=${pageNumber || 1}&pageSize=${perPage || 10}&orderCriteria=${sortCriteria}&orderField=${sortItem}&agencyKind=CONCENTRATOR`, {
    method: "GET",
    headers: { 'Content-Type': 'application/json' }
  })
  .then((response) => {
    if (response.status === 200) {
      dispatch(setConcentratorsError({ error: false }))
      return response
    } else {
      throw new Error(response.status)
    }
  })
  .catch((err) => {
    dispatch(setConcentratorsError({ error: true, code: err.status || err.message }))
    console.log(err)
  }); */
  let url = `/gamma-agencies/organizations/${organizationId || 9}/agencies?pageNumber=${pageNumber || 1}&pageSize=${perPage || 10}&orderCriteria=${sortCriteria}&orderField=${sortItem}&agencyKind=CONCENTRATOR`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;
    dispatch(setConcentratorsError({ error: false }));

    return data;
  } catch (error) {
    dispatch(
      setConcentratorsError({
        error: true,
        code: error.status || error.message,
      }),
    );
    console.log(error);
    throw error;
  }
};

const getFilteredAgencies = async (
  organizationId,
  pageNumber,
  perPage,
  sortCriteria,
  sortItem,
  filters,
  dispatch,
) => {
  /* return fetch(`${getAgencyServiceUrl()}/organizations/${organizationId || 9}/agencies?pageNumber=${pageNumber || 1}&pageSize=${perPage || 10}&orderCriteria=${sortCriteria}&orderField=${sortItem}&agencyKind=CONCENTRATOR${filters.name ? `&name=${filters.name}` : ''}${filters.number ? `&query=${filters.number}` : ''}${filters.status !== 'any' ? `&status=${filters.status}` : ''}`, {
    method: "GET",
    headers: { 'Content-Type': 'application/json' }
  })
  .then((response) => {
    if (response.status === 200) {
      dispatch(setConcentratorsError({ error: false }))
      return response
    } else {
      throw new Error(response.status)
    }
  })
  .catch((err) => {
    dispatch(setConcentratorsError({ error: true, code: err.status || err.message }))
    console.log(err)
  }); */
  let url = `/gamma-agencies/organizations/${organizationId || 9}/agencies?pageNumber=${pageNumber || 1}&pageSize=${perPage || 10}&orderCriteria=${sortCriteria}&orderField=${sortItem}&agencyKind=CONCENTRATOR${filters.name ? `&name=${filters.name}` : ""}${filters.number ? `&query=${filters.number}` : ""}${filters.status !== "any" ? `&status=${filters.status}` : ""} `;
  try {
    const response = await apiClient.get(url);
    if (response.status === 200) {
      dispatch(setConcentratorsError({ error: false }));
      const data = await response.data;
      return data;
    } else {
      throw new Error(response.status);
    }
  } catch (error) {
    dispatch(
      setConcentratorsError({
        error: true,
        code: error.status || error.message,
      }),
    );
    console.log(error);
  }
}; // Aquí

const getRoles = async () => {
  /* return fetch(`${getUsersServiceUrl()}/roles?pageNumber=1&pageSize=100&orderCriteria=ASC&orderField=name`)
    .then((response) => response.json())
    .then((json) => {
      return json
    })
    .catch((err) => console.log(err)); */
  let url = `/gamma-users/roles?pageNumber=1&pageSize=100&orderCriteria=ASC&orderField=name`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getSalePoints = async () => {
  /* return fetch(`${getAgencyServiceUrl()}/agencies?pageNumber=1&pageSize=20&orderCriteria=ASC&orderField=name&status=ENABLED&agencyKind=SALE_POINT`, {
    method: "GET",
    headers: { 'Content-Type': 'application/json' }
  })
    .then((response) => response.json())
    .then((json) => {
      return json
    })
    .catch((err) => console.log(err)); */
  let url = `/gamma-agencies/agencies?pageNumber=1&pageSize=20&orderCriteria=ASC&orderField=name&status=ENABLED&agencyKind=SALE_POINT`;
  try {
    const response = await apiClient.get(url);
    const data = response.data;
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getAllOrganizations = async () => {
  // return fetch(`${getAllOrganizationServiceUrl()}/organizations?pageNumber=1&pageSize=20&orderCriteria=ASC&orderField=name`)
  //   .then((response) => response.json())
  //   .then((json) => {
  //     return json
  //   })
  //   .catch((err) => console.log(err));
  try {
    const response = await apiClient.get(
      `/gamma-all-organizations/organizations?pageNumber=1&pageSize=20&orderCriteria=ASC&orderField=name`,
    );
    const data = response.data;
    return data;
  } catch (error) {
    console.error("Error at getAllOrganization EP: ", error);
  }
};

export const gammaServices = {
  getloggedUser,
  getGameOffers,
  getGameMode,
  getLottery,
  getAllOrganizations,
  getOrganizationAgencies,
  getOrganizationSortedAgencies,
  getFilteredAgencies,
  getRoles,
  getSalePoints,
};
